import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';
import { Notificatie } from '../../models/notificatie';

@inheritSerialization(LoadableState)
export class AnnouncementsState extends LoadableState {
  public static readonly key = 'AnnouncementsState';

  @autoserializeAs(Notificatie, 'announcements')
  public announcements: Notificatie[] = [];

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;

}
